import { Dropdown, DropdownList } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledDropdown = styled(Dropdown)`
  ${DropdownList.Styled.DropdownListRoot} {
    width: 288px;
  }
`;
